import type { ReactNode } from 'react';

// `| undefined` (not just `?`) lets callers pass `className={maybeString}`
// when `exactOptionalPropertyTypes` is on.
export type IconProps = {
  size?: number | undefined;
  color?: string | undefined;
  strokeWidth?: number | undefined;
  fill?: string | undefined;
  className?: string | undefined;
};

export type IconDef = {
  viewBox: string;
  path: ReactNode;
};

/**
 * Builds a stroke-based outline icon. Lives in its own file so that
 * `Icon.tsx` can stay 100% component exports — required for
 * react-refresh/only-export-components.
 */
export function makeIcon(def: IconDef) {
  return function Icon({
    size = 18,
    color = 'currentColor',
    strokeWidth = 1.7,
    fill = 'none',
    className,
  }: IconProps) {
    return (
      <svg
        width={size}
        height={size}
        viewBox={def.viewBox}
        fill={fill}
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden="true"
      >
        {def.path}
      </svg>
    );
  };
}
